import ArtigoPlaceholder from "@/components/feature/ArtigoPlaceholder";
export default function ArtigoPerfumes() {
  return (
    <ArtigoPlaceholder
      title="Perfumes Importados da China: Guia de Compra com CSSBuy Spreadsheet"
      desc="Encontre perfumes originais e contratipos de alta qualidade nas planilhas CSSBuy. Dicas para identificar fragrâncias autênticas e evitar falsificações."
      icon="ri-contrast-drop-line"
      slug="artigo-cssbuy-perfumes"
    />
  );
}